import {
  buildExpenseFeeCategoryFromSupplier as buildExpenseCategoryFromSupplier,
  buildExpenseFeeClassFromSupplier as buildExpenseClassFromSupplier,
} from '@/composables/expensesFees/shared/useExpenseFeeSupplierFlow';
import {
  resetExpenseFeeTaxSelection as resetExpenseTaxSelection,
  resolveExpenseFeeVoucherFlags as resolveExpenseVoucherFlags,
} from '@/composables/expensesFees/shared/useExpenseFeeTaxFlow';

export const applyVoucherTypeRules = (form = {}, voucherType = '') => {
  const flags = resolveExpenseVoucherFlags(voucherType);

  if (flags.isSimpleNoteVoucher || flags.isPayrollVoucher) {
    resetExpenseTaxSelection(form);
    form.withoutTaxes = false;
  }

  if (flags.isSimpleNoteVoucher || flags.isForeignReceiptVoucher) {
    form.supplierContributor = null;
    form.cfdiDate = null;
  }

  if (flags.isPayrollVoucher) {
    form.discount = 0;
  } else {
    form.deductions = 0;
  }
};

export const applyWithoutTaxesRules = (form = {}, withoutTaxesEnabled = false) => {
  if (!withoutTaxesEnabled) {
    return;
  }

  resetExpenseTaxSelection(form);
};

export const applySupplierAutoFillFromSupplier = (
  form = {},
  supplierOption = null,
  resolveOptionId = () => 0
) => {
  const classOption = buildExpenseClassFromSupplier(supplierOption);
  const categoryOption = buildExpenseCategoryFromSupplier(supplierOption);

  if (classOption && resolveOptionId(form?.expenseClass) <= 0) {
    form.expenseClass = classOption;
  }

  if (categoryOption && resolveOptionId(form?.expenseCategory) <= 0) {
    form.expenseCategory = categoryOption;
  }
};
